<template>
    <div class="presentation-wrapper">
        <design-2021-presentation-title-component
            :presentation-in="dynamicPresentation"
            @presentation-updated="updatePresentation">
        </design-2021-presentation-title-component>

        <div class="row">
            <div class="col-md-4 col-xl-3">
                <design-2021-presentation-edit-nav-component
                    :presentationIn="dynamicPresentation"
                    :selected-slide-id="selectedSlideId"
                    @selected-slide="selectSlide"
                    @presentation-updated="updatePresentation">
                </design-2021-presentation-edit-nav-component>
            </div>
            <div
                class="col-md-8 col-xl-9"
                v-if="selectedSlide">
                <design-2021-presentation-edit-slide-component
                    :slide-in="selectedSlide"
                    @presentation-updated="updatePresentation">
                </design-2021-presentation-edit-slide-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-edit-component',
    props: {
        presentationIn: Object,
        slideIdIn: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            presentation: this.presentationIn,
            selectedSlideId: this.slideIdIn,
        };
    },
    computed: {
        dynamicPresentation() {
            return this.presentation;
        },
        selectedSlide() {
            if (!this.selectedSlideId) {
                return this.presentation.steps[0]?.slides[0] ?? null;
            }

            for (const step of this.presentation.steps) {
                for (const slide of step.slides) {
                    if (slide.id === this.selectedSlideId) {
                        return slide;
                    }
                }
            }
            return null;
        },
    },
    methods: {
        updatePresentation(presentation) {
            this.presentation = presentation;
        },
        selectSlide(slideId) {
            this.selectedSlideId = slideId;
        },
    },
};
</script>

<style scoped lang="scss">
.presentation-edit-nav-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .presentation-edit-nav-wrapper {
        margin-bottom: 0;
    }
}
</style>
